
export const pptosReducer = (state = [], action) => {

    switch (action.type) {
        case '[PPTOS] Load list':
            return {
                ...state,
                pptos: action.payload
            }

        case '[PPTOS] Load templates':
            return {
                ...state,
                templates: action.payload
            }

        case '[PPTOS] Get Data template':
            return {
                ...state,
                detailTemplate: action.payload
            }

        case '[PPTOS] Get Motivos':
            return {
                ...state,
                motivosList: action.payload
            }

        default:
            return state
    }


}